import React,{useEffect,useRef} from 'react';
import { useDispatch } from 'react-redux';
import BasePage from '../common/base';
import { AlertTransactionsContainer } from './alert-transactions.container';
import { Container } from '@material-ui/core';
import { DashboardStyles } from '../../hooks/styles';
import {Constants} from "../../constants/Constants";

const Products = () => {
  const classes = DashboardStyles();
  const isFirstRender = useRef(true)
  const dispatch = useDispatch();
  useEffect(() => {
    isFirstRender.current = false
  }, [dispatch])

  return (
    <BasePage title={Constants.PAGE_TITLE.RX_EXCEPTIONS}>
      <div className={classes.appBarSpacer}></div>
      <Container maxWidth={false} className={classes.container}>
        <AlertTransactionsContainer />
      </Container>
    </BasePage>
  )
}

export default Products;